import type { JSX } from 'solid-js';
import { splitProps } from 'solid-js';
import { classNames } from '../lib/classes';

type Props = JSX.TextareaHTMLAttributes<HTMLTextAreaElement>;

export function Textarea(props: Props) {
  const [local, rest] = splitProps(props, ['class']);
  return (
    <textarea
      class={classNames(
        'w-full rounded-md border border-border bg-card p-3 font-mono text-xs text-fg placeholder:text-muted',
        'focus:outline-2 focus:outline-offset-0 focus:outline-tea-500',
        'disabled:opacity-50',
        local.class,
      )}
      {...rest}
    />
  );
}
